import React from 'react';
import { CiHeadphones } from 'react-icons/ci';
import { useEventContext } from '../../context/EventProvider';

const Assistance = () => {
  const {
    event
  } = useEventContext();
  const { email, emailSubject } = event || {};

  const emailString = `mailto:${email}}?subject=Registration Assistance: ${emailSubject}`;

  return (
    <a
      href={emailString}
      className="no-underline cursor-pointer uppercase w-[140px] h-8 px-3 py-2 bg-gray-100 rounded-lg border border-gray-200 justify-center items-center gap-2 inline-flex mt-4"
    >
      <div className="w-4 h-4 relative" />
      <div className="text-blue-600 text-[10px] font-medium font-['Inter'] leading-[15px]">
        <CiHeadphones className="scale-[1.7]" />{' '}
        <span className="ml-2">Need Assistance</span>
      </div>
    </a>
  );
};

export default Assistance;
